module.exports = __webpack_public_path__ + "static/hero-5d5f9028885036980dfce197d0137b9f.png";